<template>
  <template v-if="productTypeId === ProductIds.REFI"
    >Your application is currently under review. Please see the
    <a
      class="inline-link"
      aria-description="link to scroll to the todo list when using a mobile device"
      @click="emit('todoListClicked')"
      >To-Do List</a
    >
    below for information you need to provide. If no action is requested, we'll be in touch shortly
    with an update. If you wish to contact our processors or share the best way to get ahold of you,
    you can email our team directly by clicking
    <a
      class="inline-link"
      :href="`mailto:${emailAddress}`"
      aria-description="link to email the support team"
      >here</a
    >.</template
  >
  <template v-else>
    <p class="opal-alert">
      Please check your To-Do list to see if any action is needed during this process.
    </p>
    <p>
      Your application is currently under review, and we'll be in touch shortly. If you wish to
      contact our processors or share the best way to get ahold of you, you can email our team
      directly by clicking
      <a
        class="inline-link"
        aria-description="link to email the support team"
        :href="`mailto:${emailAddress}`"
        >here</a
      >.
    </p></template
  >
</template>
<script setup lang="ts">
import { computed, defineEmits } from "vue";
import { ProductIds } from "@/config/constants";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import { TimelineMilestone } from "@/models/applicationStatus";

const emit = defineEmits<{
  (e: "todoListClicked"): void;
}>();

const { productTypeId, timeline, emailAddress } = useApplicationStatus();

const steps = computed(() => timeline.value.filter((s: TimelineMilestone) => s.step > 1));
</script>
